import * as React from "react"
import { SVGProps } from "react"
const AttachDocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26.889} height={34} {...props}>
    <g
      fill="none"
      stroke="#2c3e50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      data-name="Component 6466 \u2013 8"
    >
      <path
        d="M17 1v7.111a1.778 1.778 0 0 0 1.778 1.778h7.111"
        data-name="Path 5884"
      />
      <path
        d="M22.333 33H4.556A3.556 3.556 0 0 1 1 29.444V4.556A3.556 3.556 0 0 1 4.556 1H17l8.889 8.889v19.555A3.556 3.556 0 0 1 22.333 33Z"
        data-name="Path 5885"
      />
      <path d="M8.111 11.667h1.778" data-name="Path 5886" />
      <path d="M8.111 18.778h10.667" data-name="Path 5887" />
      <path d="M8.111 25.889h10.667" data-name="Path 5888" />
    </g>
  </svg>
)
export default AttachDocumentIcon
